import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToggleReusable } from '../toggle-reusable/toggle-reusable';

/**
 * Bordered setting row — title, helper text and a switch on the right — with
 * an optional amber note shown while the switch is off (e.g. "hidden from users").
 */
@Component({
  selector: 'app-toggle-card-reusable',
  standalone: true,
  imports: [ToggleReusable],
  host: { '[attr.title]': 'null', class: 'block space-y-3' },
  template: `
    <div class="flex items-center justify-between gap-4 rounded-lg border border-slate300 bg-white px-3 py-2.5">
      <div class="min-w-0">
        <p class="text-base font-semibold text-slate900">{{ title }}</p>
        @if (description) {
          <p class="mt-0.5 text-xs text-slate600">{{ description }}</p>
        }
      </div>
      <app-toggle-reusable [control]="control" type="green" [label]="''" [disabled]="disabled"></app-toggle-reusable>
    </div>
    @if (offWarning && !control.value) {
      <p class="flex items-center gap-2 rounded-lg border border-amber300 bg-amber50 px-3 py-2.5 text-xs font-medium text-amber700" role="note">
        <svg class="shrink-0" width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M8.57 3.22 1.51 15a1.67 1.67 0 0 0 1.43 2.5h14.12a1.67 1.67 0 0 0 1.43-2.5L11.43 3.22a1.67 1.67 0 0 0-2.86 0Z" fill="#F59E0B" />
          <path d="M10 7.5v3.33M10 14.17h.01" stroke="#fff" stroke-width="1.6" stroke-linecap="round" />
        </svg>
        {{ offWarning }}
      </p>
    }
  `,
})
export class ToggleCardReusableComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() offWarning = '';
  @Input() disabled = false;
  @Input({ required: true }) control!: FormControl<boolean | null>;
}
